import { useTranslation } from 'react-i18next';
import VideoPoster from '../../assets/535fbac30da553a0.jpg';
import Video from '../../assets/535fbac30da553a0.mp4';
import { FrameLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { H10, SubH1 } from '../../common/common-text';
import i18n from '../../common/i18n/i18n';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';
import useVisualViewportHeight from '../../hooks/useVisualViewportHeight';

const CISection1 = () => {
  const { t } = useTranslation();
  const { horizontal: padding, topSectionBottom: topSectionBottom } = useResponsivePadding(/*{ mode: 'fixed' }*/);
  const viewheight = useVisualViewportHeight();
  const { isMobile } = useDeviceType();
  const isEng = ['en', 'en-mobile'].includes(i18n.language);
  const isChina = ['zh', 'zh-mobile'].includes(i18n.language);

  return (
    <VerticalLayout style={{
      background: 'black',
      ...(isMobile ? { height: viewheight } : {}),
    }}>
      <FrameLayout>
        <video
          src={Video}
          autoPlay
          muted
          loop
          playsInline
          poster={VideoPoster}
          style={{
            width: '100%',
            height: isMobile ? '100%' : 'auto',
            display: 'block',
            objectFit: 'cover',
          }}
        />
        <SubH1
          style={{
            color: 'white',
            position: 'absolute',
            left: `${padding}px`,   // ✅ 좌측 여백
            bottom: isMobile ? isEng ? '158px' : '114px' : `${topSectionBottom}px`
          }}
        >
          Our Brand
        </SubH1>
        <H10
          style={{
            width: isMobile ? `calc(100% - ${padding * 2}px)` : pxToRem(510),
            color: 'white',
            position: 'absolute',
            bottom: isMobile ? '0px' : `${topSectionBottom}px`,
            left: isMobile ? `${padding}px` : undefined,
            right: isMobile ? undefined : `${padding}px`,
            ...(isMobile
              && { minHeight: isEng ? '146px' : `102px` }),
          }}
        >
          {t('비비테크의 로고는 정밀함과 안정감을 바탕으로 한 기술 신뢰의 상징입니다. 20년간 축적한 노하우와 미래를 향한 비전을 담아, 한결같은 품질과 혁신을 표현합니다.')}
        </H10>
      </FrameLayout>
    </VerticalLayout>
  );
};

export default CISection1;
